import type * as SpreadSheetsTypes from '@mescius/spread-sheets';

import { config } from '@/config';
import { logWarn } from '@/lib/logger';

let gcPromise: Promise<typeof SpreadSheetsTypes> | null = null;
let gcInstance: typeof SpreadSheetsTypes | null = null;

/**
 * Load SpreadJS library once globally.
 * Subsequent calls return the cached instance immediately.
 */
export function loadSpreadJS(): Promise<typeof SpreadSheetsTypes> {
  // Return cached instance immediately if already loaded
  if (gcInstance) {
    return Promise.resolve(gcInstance);
  }

  // Return existing promise if load is in progress
  if (gcPromise) {
    return gcPromise;
  }

  // Start loading
  gcPromise = (async () => {
    const GC = await import('@mescius/spread-sheets');

    // Set license key
    if (config.spreadJSLicenseKey) {
      GC.Spread.Sheets.LicenseKey = config.spreadJSLicenseKey;
    } else {
      logWarn('VITE_SPREADJS_LICENSE_KEY environment variable is not set.');
    }

    gcInstance = GC;
    return GC;
  })();

  return gcPromise;
}

/**
 * Get the loaded SpreadJS instance.
 * Returns null if not yet loaded.
 */
export function getSpreadJS(): typeof SpreadSheetsTypes | null {
  return gcInstance;
}

/**
 * Check if SpreadJS is loaded.
 */
export function isSpreadJSLoaded(): boolean {
  return gcInstance !== null;
}
